<template>
    <div class="simplified-query-builder">
        <p class="d-flex text-row mb-3" v-if="data_filter.logic_units.length > 0" >Match
            <select class="form-select w-auto mx-2" v-model="inverted" v-on:change.prevent="setInverted()" :disabled="!if_allow_edit" aria-label="Inverted">
                <option :value="false">All</option>
                <option :value="true">Any</option>
            </select>
            filters:
        </p>

        <div class="row mx-1">
            <div class="col-12 condition-grouping mb-5" v-if="data_filter.logic_units.length > 0" :class="{inverted: inverted, white: is_white, 'has-group-number': nested_units.length > 1}" v-for="(unit, index) in nested_units">
                <span class="condition-group-number mt-1 ms-1" v-if="nested_units.length > 1">{{index + 1}}. </span>
                <div class="w-100">
                    <h4 class="d-block d-md-none">Condition Group {{index +1 }}</h4>
                    <div class="row w-100 position-relative condition-group-child" 
                    :class="el_index == unit.length-1 ? 'my-0 my-md-2' : 'my-2'"
                    v-for="(el, el_index) in unit"  v-bind:class="{ 'is-invalid' : hasLogicUnitError(data_filter.logic_units[el]) && errors.logic_units[el]}">

                        <span class="logic-operator-text d-block d-md-none" v-if="el_index>0" >{{inverted? "AND " : "OR "}}</span>
                  
                        <div class="condition-group-child-card row ms-2 align-items-center" :class="{'has-clause-number': unit.length > 1}">
                            <div class="clause-order-number" v-if="unit.length > 1">{{el_index + 1}}</div> 
                            <h6 class="d-inline d-md-none mb-0 d-flex justify-content-between">
                                Condition {{el_index + 1 }}
                                <div>
                                    <button v-if="if_allow_edit" class="btn btn-none btn-sm d-flex align-items-center px-0" v-on:click="removeLogicUnit(el)">
                                        <img class="icon p-0" src="/img/icons/avid-icons/trash.svg" alt="">
                                    </button>
                                    <div v-else data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                        <button class="btn btn-none btn-sm d-flex align-items-center px-0" :disabled="true">
                                            <img class="icon p-0" src="/img/icons/avid-icons/trash.svg" alt="">
                                        </button>
                                    </div>
                                </div>
                            </h6>
                            <div class="col-md-3 col-12 d-flex align-items-center">
                                <div class="flex-row d-flex align-items-center w-100">
                                    <div class="col-12">
                                        <input v-if="data_filter.logic_units[el] && data_filter.logic_units[el].db_column && data_filter.logic_units[el].db_column.if_sql_value" :value="(data_filter.logic_units[el].db_column.category) ? 
                                            data_filter.logic_units[el].db_column.category + ': ' + data_filter.logic_units[el].db_column.text : data_filter.logic_units[el].db_column.text"
                                            class="form-control" disabled data-bs-toggle="tooltip" title="Calculated fields cannot be edited" aria-label="Text input">
                                        <v-select v-else :options="db_columns" v-model="data_filter.logic_units[el].db_column"
                                            :searchable="true" class="searchable-select column-display category"
                                            :selectable="(option) => option.text != ''"
                                            placeholder="Field"
                                            @search="fetchOptions" label="text"  :filterable="false" data-bs-toggle="tooltip"
                                            :data-bs-original-title="data_filter.logic_units[el]&& data_filter.logic_units[el].db_column ? data_filter.logic_units[el].tooltip_title : ''"
                                            @open="handleColumnDisplayOpen(el)"
                                            @update:modelValue="handleDatabaseColumnChange(el)"
                                            :key="'column-select-' + el"
                                            :disabled="!if_allow_edit">

                                            <template #selected-option="{ text, category, subcategory }">
                                                {{(category != null && category != "" && category != "list-header" ? category + ": " : "")}}{{subcategory != null && subcategory != "" ? subcategory + " › " : ""}}{{text}}
                                            </template>

                                            <template #open-indicator="{ attributes }">
                                                <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
                                            </template>

                                            <template #option="{ text, category, subcategory }">
                                                <div v-if="text == '' && !subcategory" :data-category="category" class="category-header"
                                                    v-on:click="expandCategory(category, null)"
                                                    @mouseover="handleHover($event)"
                                                    data-isexpanded="false">
                                                    {{ category }} <i class="fas fa-caret-right"></i>
                                                </div>
                                                <div v-else-if="text == '' && subcategory"
                                                    :data-subcategory="category"
                                                    :data-subcategory-name="subcategory"
                                                    class="subcategory-header"
                                                    @click="expandSubcategory(category, subcategory, null)"
                                                    @mouseover="handleHover($event)"
                                                    data-isexpanded="false"
                                                    v-show="isSubcategoryVisible(category, subcategory)">
                                                    {{ subcategory }} <i class="fas fa-caret-right"></i>
                                                </div>
                                                <div v-else class="suboption" :data-subcategory="category" :data-subcategory-name="subcategory"
                                                    :class="shouldShowOption(category, subcategory)"
                                                    @mouseover="handleHover($event)">
                                                    {{getDisplayText(text)}}
                                                </div>
                                            </template>

                                            <template #no-options="{ search, searching, loading }">
                                                <div class="suboption show" v-if="is_loading">
                                                    <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Loading...</span></div>  Loading columns
                                                </div>
                                                <div class="suboption show" v-else>
                                                    <em>No results found</em>
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3 col-12 operations text-md-center text-start d-flex align-items-center" >                                
                                <v-select :options="data_filter.logic_units[el].operator_option_type == 'short' ? getOperatorOptions(data_filter.logic_units[el]) : operator_options"
                                    v-model="data_filter.logic_units[el].operator"
                                    placeholder="Condition"
                                    :selectable="(option) => option.text != ''" label="text"
                                    @update:modelValue="updateOperator(data_filter.logic_units[el]);"
                                    :searchable="true" @search="fetchOperators"
                                    class="operator-select w-100"
                                    ref="operatorSelect"
                                    @open="handleOperatorOpen(el)"
                                    :disabled="!if_allow_edit"
                                    :key="'operator-select-' + el">

                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
                                    </template>

                                    <template #option="{ text, category }">
                                        <div v-if="text == ''" :data-category="category" class="category-header operator-category"
                                            @click.prevent="expandOperatorCategory(category, null)"
                                            :data-isexpanded="false"
                                            @mouseover="handleOperatorHover($event)">
                                            {{ category }} <i class="fas fa-caret-down"></i>
                                        </div>
                                        <div v-else class="suboption operator-option"
                                            :class="{ show: shouldShowClass(el) }"
                                            :data-category="category"
                                            @mouseover="handleOperatorHover($event)">
                                            {{ text }}
                                        </div>
                                    </template>

                                    <template #list-footer="{ search }">
                                        <li class="border-top border-primary border-1 text-center" @click.prevent="loadFullOperatorList(el)" v-if="data_filter.logic_units[el].operator_option_type != 'full'">
                                            <a class="btn btn-sm btn-link pb-0 text-nowrap"> <i class="fas fa-eye"></i>View All Operators</a>
                                        </li>
                                    </template>
                                </v-select>
                            </div>

                            <div class="col-md-4 col-12 text-md-center text-start d-flex align-items-center position-relative" v-if="shouldShowValues(data_filter.logic_units[el].operator)">                           
                                <v-select v-if="shouldShowSelect(data_filter.logic_units[el])" :id="'id-'+el" :options="getOptions(data_filter.logic_units[el])" v-model="data_filter.logic_units[el].value"
                                    :searchable="true" ref="valueSelect" class="searchable-select vue-multi-select w-100"
                                    :selectable="(option) => option.text != ''" @open="setEditingIndex(el)" @close="handleBlur(el)"
                                    placeholder="Value"
                                    label="text" @search="debouncedSearchOptions"  :map-keydown="handleEnter"
                                    :filterable="false" multiple
                                    :key="'value-select-' + el"
                                    :disabled="!if_allow_edit">

                                    <template #list-header="{ search }">
                                        <li class="border-bottom border-primary border-1" @click.prevent="addEntryToValue(el, search)" v-if="search != ''">
                                            <a class="btn btn-link"><i class="fas fa-circle-plus text-primary"></i> Add Entry</a>
                                        </li>
                                    </template>

                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
                                    </template>

                                    <template #option="{ text, category }">
                                        <div v-if="text == ''" :data-category="category" class="category-header"
                                        v-on:click="expandCategory(category, null)"
                                        data-isexpanded="false">
                                        {{ category }} <i class="fas fa-caret-right"></i>
                                        </div>
                                        <div v-else class="suboption" :data-subcategory="category"
                                        :class="category==null || category==''? 'show' : ''">
                                        {{ text }}
                                        </div>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        <div class="suboption show" v-if="is_loading">
                                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Loading...</span></div>  Loading columns
                                        </div>
                                        <div class="suboption show" v-else-if="is_searching">
                                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Searching...</span></div>  Searching
                                        </div>
                                        <div class="suboption show" v-else>
                                            <em>No results found</em>
                                        </div>
                                    </template>
                                </v-select>
                                <div v-else-if="shouldShowDate(data_filter.logic_units[el])" class="input-group date-input-group">
                                    <button class="btn btn-white dropdown-toggle date-type-toggle" 
                                        type="button" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false"
                                        :disabled="!if_allow_edit || !data_filter.logic_units[el].db_column || !data_filter.logic_units[el].db_column.value">
                                        <span v-html='typeOfSelection(data_filter.logic_units[el])'></span>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-primary">
                                        <li>
                                            <a class="dropdown-item" href="#"
                                                v-on:click.prevent="data_filter.logic_units[el].is_static = false; data_filter.logic_units[el].show_options = true; data_filter.logic_units[el].value = '';">
                                                Date Comparisons
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#"
                                                v-on:click.prevent="data_filter.logic_units[el].is_static = true; data_filter.logic_units[el].show_options = false; data_filter.logic_units[el].value = '';">
                                                Static Value
                                            </a>
                                        </li>
                                    </ul>

                                    <!-- Static Date Picker -->
                                    <datepicker-utc 
                                        v-if="data_filter.logic_units[el].is_static && !data_filter.logic_units[el].show_options"
                                        v-model="data_filter.logic_units[el].value" 
                                        inputFormat="M/d/yyyy"
                                        :placeholder="'Date'"
                                        input-class="form-control"
                                        :disabled="!if_allow_edit" />

                                    <!-- Date Comparisons (Number + Select) -->
                                    <template v-if="!data_filter.logic_units[el].is_static && data_filter.logic_units[el].show_options">
                                        <input type="number" 
                                            class="form-control date-comparison-num"
                                            v-bind:value="dateNumCalc(data_filter.logic_units[el].value)"
                                            v-bind:data-index="el" 
                                            placeholder="###"
                                            v-on:change="updateDateValue(el, data_filter.logic_units[el]);"
                                            :disabled="!if_allow_edit" aria-label="Number">

                                        <select class="form-select date-comparison-select"
                                            v-bind:value="dateComparisonCalc(data_filter.logic_units[el].value)"
                                            v-bind:data-index="el"
                                            v-on:change="updateDateValue(el, data_filter.logic_units[el]);"
                                            :disabled="!if_allow_edit" aria-label="Select option">
                                            <option value="day">Days Ago</option>
                                            <option value="week">Weeks Ago</option>
                                            <option value="month">Months Ago</option>
                                            <option value="year">Years Ago</option>
                                        </select>
                                    </template>
                                </div>
                                <div v-else-if="shouldShowFileSelection(data_filter.logic_units[el])" :class="(data_filter.logic_units[el].selected_file != null && !isSegmentOperator(data_filter.logic_units[el].operator)) ? 'input-group' : 'w-100'">
                                    <v-select v-model="data_filter.logic_units[el].selected_file"
                                        :options="getAvailableOptions(data_filter.logic_units[el])"
                                        :searchable="true"
                                        data-bs-toggle="tooltip" 
                                        :data-bs-original-title="data_filter.logic_units[el].selected_file?.text"
                                        label="text"
                                        :placeholder="getPlaceholderText(data_filter.logic_units[el])"
                                        @search="debouncedSearchFiles"
                                        @update:modelValue="handleFileSelection(el)"
                                        class="searchable-select column-display category"
                                        :class="(data_filter.logic_units[el].selected_file && !isSegmentOperator(data_filter.logic_units[el].operator)) ? 'w-50 me-0' : 'w-100'"
                                        :key="'file-select-' + el"
                                        :disabled="!if_allow_edit">
                                        <template #option="{ text, created_at, type, source }">
                                            <div class="suboption show text-wrap">
                                                {{ text }} 
                                                <small class="text-muted" v-if="type === 'file'">
                                                    (Uploaded: {{ formatDate(created_at) }})
                                                </small>
                                            </div>
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            <div class="suboption show" v-if="is_loading">
                                                <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Loading...</span></div>  {{ getLoadingText(data_filter.logic_units[el]) }}
                                            </div>
                                            <div class="suboption show" v-else>
                                                <em>No Results Found</em>
                                            </div>
                                        </template>
                                        <template #list-footer="{ search }">
                                            <li v-if="hasMoreFiles && (data_filter.logic_units[el].operator.value === 'IN_FILE' || data_filter.logic_units[el].operator.value === 'NOT_IN_FILE')" class="border-top border-primary border-1 text-center">
                                                <a class="btn btn-sm btn-link pb-0 text-nowrap" @click.prevent="loadMoreFiles">
                                                    Load More
                                                </a>
                                            </li>
                                        </template>
                                    </v-select>
                                    <v-select v-if="data_filter.logic_units[el].selected_file && !isSegmentOperator(data_filter.logic_units[el].operator)"
                                        v-model="data_filter.logic_units[el].selected_column"
                                        :options="data_filter.logic_units[el].selected_file.columns"
                                        :searchable="true"
                                        label="label"
                                        data-bs-toggle="tooltip"
                                        :data-bs-original-title="data_filter.logic_units[el].selected_column?.label"
                                        :title="data_filter.logic_units[el].selected_column?.label"
                                        placeholder="Column"
                                        @update:modelValue="handleColumnSelection(el)"
                                        class="searchable-select column-display category w-50"
                                        :key="'column-select-file-' + el"
                                        :disabled="!if_allow_edit">
                                        <template #option="{ id, label }">
                                            <div class="suboption show">{{ label }}</div>
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            <div class="suboption show" v-if="is_loading">
                                                <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Loading...</span></div>  Loading columns
                                            </div>
                                            <div class="suboption show" v-else>
                                                <em>No results found</em>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="flex-grow-1 d-flex flex-column" v-else>
                                    <input class="form-control" v-model="data_filter.logic_units[el].value" :disabled="!if_allow_edit" placeholder="Value" aria-label="Value">
                                    <!-- File ID Column Validation Error -->
                                    <div class="invalid-feedback text-start d-block" 
                                        :class="data_filter.logic_units[el].validation_error && data_filter.logic_units[el].validation_error.includes('Info:') ? 'text-muted' : ''" >
                                        <span v-html="data_filter.logic_units[el].validation_error"></span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-md-2 col-12 d-flex gap-2 justify-content-md-center justify-content-start align-items-center ps-md-2">
                                <button v-if="if_allow_edit" class="btn btn-white btn-icon-only-md" v-on:click="addLogicUnit(index)">
                                    {{inverted? "AND" : "OR"}}
                                </button>
                                <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                    <button class="btn btn-secondary btn-icon-only-md" :disabled="true">
                                         {{inverted? "AND" : "OR"}}
                                    </button>
                                </div>
                                <button v-if="if_allow_edit" class="btn btn-warning btn-icon-only-md" v-on:click="removeLogicUnit(el)">
                                    <img class="icon p-0" src="/img/icons/avid-icons/trash.svg" alt="">
                                </button>
                                <div v-else data-bs-toggle="tooltip btn-icon-only-md" title="You do not have privileges to complete this action">
                                    <button class="btn btn-warning" :disabled="true">
                                        <img class="icon p-0" src="/img/icons/avid-icons/trash.svg" alt="">
                                    </button>
                                </div>
                            </div>

                            <div class="pb-2 ps-3 invalid-feedback col-12" v-if="hasLogicUnitError(data_filter.logic_units[el]) && errors.logic_units[el]">
                                <span v-if="data_filter.logic_units[el].column_removed_error" v-html="data_filter.logic_units[el].column_removed_error"></span>
                                <span v-else>All of the fields must be completed.</span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="w-100 position-relative" v-if="index != nested_units.length-1">
                    <div class="btn btn-secondary btn-sm condition-grouping-operator">{{inverted? "OR" : "AND"}}</div>
                </div>
            </div>
        </div>

        <div class="add-condition d-md-flex d-block align-items-center my-0">
            <button class="btn btn-secondary h-auto me-3" v-if="if_allow_edit" v-on:click="addLogicUnit(-1)">
                <i class="fas fa-plus"></i> Add Condition
            </button>
            <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                <button class="btn btn-secondary h-auto me-3" :disabled="true">
                    <i class="fas fa-plus"></i> Add Condition
                </button>
            </div>

            <div class="form-check" v-if="data_filter.logic_units.length > 0" >
                <label class="form-check-label d-flex align-items-center">
                <input :disabled="!if_allow_edit" class="form-check-input" type="checkbox" value="LOWER" v-model="data_filter.logic_units_modification" @change="updateModification()">
                <small class="ms-2 mt-1">Match text without case (Case Insensitive)</small>
                </label>
            </div>
        </div>
    </div>

    </template>

    <script>
        import debounce from 'lodash.debounce';
        import moment from 'moment';
        import vSelect from "vue3-select";

        export default {
            props: {
                modelValue: {
                    type: Object,
                },
                client: {
                    type: Object,
                    required: true
                },
                source: {default: 'client_db' },
                data_source_id: {default: null },
                static_db_columns: {default: null },
                include_trans: {default: false },
                is_white: {default: true },
                add_blank: {default: true },
                if_allow_edit: {default: true }
            },
            emits: ['update:modelValue'],
            components: {
                vSelect,
            },
            data() {
                return {
                    db_columns: [],
                    unfiltered_db_columns: [],
                    db_column_values: [],
                    unfiltered_db_column_values: [],
                    db_search: [],
                    debouncedSearchOptions: null,
                    debouncedSearchFiles: null,
                    editing_index: null,
                    errors: {
                        logic_units: [ false ]
                    },
                    data_filter: {
                        logic_units: [],
                        filter_logic: '',
                        filter_ui: 'simple',
                        filter_option: 'custom',
                        logic_units_modification: 0
                    },
                    inverted: false,
                    is_loading: false,
                    is_searching: false,
                    unfiltered_operator_options: [],
                    operator_options: [],
                    column_types: {},
                    expanded_categories: [],
                    expanded_subcategories: [],
                    expanded_operator_categories: [],
                    available_files: [],
                    available_datasets: [],
                    available_segments: [],
                    file_columns: [],
                    file_search_offset: 0,
                    file_search_pattern: '',
                    hasMoreFiles: false,
                    total_files: 0,
                    total_datasets: 0,
                    files_loaded: false, // Add this flag
                    isUpdatingFromModel: false, // Flag to prevent infinite loops in modelValue watcher
                };
            },
            created() {
                this.debouncedSearchOptions = debounce(this.searchOptions, 500);
                this.debouncedSearchFiles = debounce(this.searchFiles, 500);
                this.debouncedValidateFileIDColumn = debounce(this.validateFileIDColumn, 500);
            },
            beforeMount() {
                if(this.modelValue != null){
                    // Some API responses initialize the filter as an empty array ([]) instead of an object. Convert that to a blank
                    // data filter so the component has all of the expected keys.
                    if(Array.isArray(this.modelValue)) {
                        this.data_filter = this.getBlankDataFilter();
                    } else {
                        this.data_filter = JSON.parse(JSON.stringify(this.modelValue));
                    }
                    
                    // Ensure data_filter and logic_units exist
                    if (!this.data_filter) {
                        this.data_filter = this.getBlankDataFilter();
                    }
                    if (!this.data_filter.logic_units) {
                        this.data_filter.logic_units = [];
                    }

                    if(this.data_filter.logic_units.length == 0 && this.add_blank){
                        this.data_filter.logic_units.push({
                            db_column: null,
                            data_type:'string',
                            operator: null,
                            is_static: true,
                            show_options: false,
                            value:[],
                            modification: this.data_filter.logic_units_modification,
                            operator_option_type: 'short',
                            tooltip_title: '',
                            column_removed_error: null
                        });
                        this.data_filter.filter_logic = '1';
                    }
                    //If filter logic has been removed...
                    else if(this.data_filter.filter_logic == null || this.data_filter.filter_logic == '') {
                        this.data_filter.filter_logic = '';
                        for(var i = 0; i < this.data_filter.logic_units.length; i++)
                            this.data_filter.filter_logic += (i+1) + " AND ";
                        //Remove the last and
                        if(this.data_filter.filter_logic.length > 5)
                            this.data_filter.filter_logic = this.data_filter.filter_logic.substring(0, this.data_filter.filter_logic.length - 5);
                    }

                    // Ensure all logic units have operator_option_type set to 'short'
                    this.data_filter.logic_units.forEach(unit => {
                        unit.operator_option_type = 'short';
                        // Ensure column_removed_error field exists
                        if (!unit.hasOwnProperty('column_removed_error')) {
                            unit.column_removed_error = null;
                        }
                    });

                    // Check for file/dataset operators and load options if needed
                    const hasFileDatasetOperator = this.data_filter.logic_units.some(unit => {
                        if (!unit.operator) {
                            return false;
                        }
                        const operator = typeof unit.operator === 'object' ? unit.operator.value : unit.operator;
                        if(operator == null || operator == '')
                            return false;
                        return operator.indexOf('IN_') != -1;
                    });

                    if (hasFileDatasetOperator) {
                        this.loadAvailableFiles();
                    }
                }
                else
                    this.data_filter = this.getBlankDataFilter();

                this.data_filter.filter_ui = "simple";
                this.data_filter.filter_option = 'custom';
                this.inverted = this.isInverted(this.data_filter.filter_logic);
                this.unfiltered_operator_options = [
                    { category: "Common Operators", value: '', text: '' },
                    { category: "Common Operators", value: '=', text: 'Equals' },
                    { category: "Common Operators", value: '<>', text: 'Does Not Equal' },
                    { category: "Common Operators", value: 'IS NULL', text: 'Is Blank' },
                    { category: "Common Operators", value: 'IS NOT NULL', text: 'Is Not Blank' },

                    { category: "Text Operators", value: '', text: '' },
                    { category: "Text Operators", value: 'LIKE', text: 'Contains' },
                    { category: "Text Operators", value: 'NOT LIKE', text: 'Does Not Contain' },
                    { category: 'Text Operators', value:"REGEXP_CONTAINS", text: 'Contains (Regex)' },
                    { category: 'Text Operators', value:"NOT REGEXP_CONTAINS", text: 'Does Not Contain (Regex)' },

                    { category: "Number Operators", value: '', text: '' },
                    { category: "Number Operators", value: '>', text: '>' },
                    { category: "Number Operators", value: '>=', text: '>=' },
                    { category: "Number Operators", value: '<', text: '<' },
                    { category: "Number Operators", value: '<=', text: '<=' },

                    { category: "Date Operators", value: '', text: '' },
                    { category: "Date Operators", value: '>', text: 'Is After' },
                    { category: "Date Operators", value: '>=', text: 'Is On or After' },
                    { category: "Date Operators", value: '<', text: 'Is Before' },
                    { category: "Date Operators", value: '<=', text: 'Is On or Before' },

                    { category: "Comparison Operators", value: '', text: '' },
                    { category: "Comparison Operators", value: 'IN_FILE', text: 'Is In File' },
                    { category: "Comparison Operators", value: 'NOT_IN_FILE', text: 'Is Not In File' },
                    { category: "Comparison Operators", value: 'IN_DATASET', text: 'Is In Dataset' },
                    { category: "Comparison Operators", value: 'NOT_IN_DATASET', text: 'Is Not In Dataset' },
                    //{ category: "Comparison Operators", value: 'IN_AUDIENCE', text: 'Is In Audience' },
                    //{ category: "Comparison Operators", value: 'NOT_IN_AUDIENCE', text: 'Is Not In Audience' },

                ];
                this.operator_options = [...this.unfiltered_operator_options];

                //Update the operator to be an object if it already isn't one
                var nested_units = this.nested_units;
                if(nested_units != null)
                    for(var i = 0; i< nested_units.length; i++) {
                        for(var j = 0; j < nested_units[i].length; j++) {
                            if(this.data_filter.logic_units.length > 0 && this.data_filter.logic_units[nested_units[i][j]] && typeof this.data_filter.logic_units[nested_units[i][j]].operator == 'string' ){
                                var op = this.data_filter.logic_units[nested_units[i][j]].operator;

                                //Find the op in the operator_options array for the value
                                for(var k = 0; k < this.unfiltered_operator_options.length; k++) {
                                    if(this.unfiltered_operator_options[k].value == op) {
                                        op = this.unfiltered_operator_options[k];
                                        break;
                                    }
                                }

                                this.data_filter.logic_units[nested_units[i][j]].operator = op;
                            }
                            // Ensure operator_option_type is set to 'short' by default
                            if (this.data_filter.logic_units[nested_units[i][j]] && 
                                !this.data_filter.logic_units[nested_units[i][j]].operator_option_type) {
                                this.data_filter.logic_units[nested_units[i][j]].operator_option_type = 'short';
                            }
                            // Ensure column_removed_error field exists
                            if (this.data_filter.logic_units[nested_units[i][j]] && 
                                !this.data_filter.logic_units[nested_units[i][j]].hasOwnProperty('column_removed_error')) {
                                this.data_filter.logic_units[nested_units[i][j]].column_removed_error = null;
                            }
                        }
                    }
            },
            mounted() {
                if(this.data_source_id){
                    this.loadDropdownColumns();
                    this.initTooltips();
                }

                // Trigger validation for existing comparison operators (file/dataset) on initial load
                this.$nextTick(() => {
                    if (this.data_filter && this.data_filter.logic_units) {
                        this.data_filter.logic_units.forEach((unit, idx) => {
                            if (
                                this.isFileOperator(unit.operator) &&
                                unit.db_column &&
                                unit.selected_file &&
                                unit.selected_column
                            ) {
                                // Call immediate validation for each clause on initial load to ensure every clause gets validated
                                this.validateFileIDColumn(idx);
                            }
                        });
                    }
                });
            },
            updated() {
                this.initTooltips();
            },
            computed: {
                nested_units() {
                    //In this case, OR is the outer unit
                    var split = "AND";
                    if(this.inverted)
                        split = "OR";

                    var logic = this.data_filter.filter_logic;

                    if((logic == null || logic == '') &&  this.data_filter.logic_units.length == 0)
                        return null;
                    else if(logic == null)
                        logic = '1';

                    logic = logic.replaceAll("(", "").replaceAll(")", "").replaceAll("NOT", "");
                    var units = logic.split(split).filter(Boolean);
                    //Write a statement to remove all ( and ) from the string

                    var arr = [];
                    for(var i = 0; i < units.length; i++) {
                        arr.push( units[i].split(this.inverted?"AND":"OR").map(function(item) {
                          return parseInt(item.trim())-1;
                        }));
                    }
                    return arr;
                },
            },
            watch: {
                modelValue: {
                    handler(newVal) {
                        if (this.isUpdatingFromModel) return;
                        
                        this.isUpdatingFromModel = true;
                        if(newVal != null && !Array.isArray(newVal)) {
                            this.data_filter = JSON.parse(JSON.stringify(newVal));
                        } else if(Array.isArray(newVal)) {
                            // Treat array payloads as an empty filter object
                            this.data_filter = this.getBlankDataFilter();
                         } else if(newVal == null) {
                             this.data_filter = this.getBlankDataFilter();
                         }
                        // Ensure data_filter and logic_units exist
                        if (!this.data_filter) {
                            this.data_filter = this.getBlankDataFilter();
                        }
                        if (!this.data_filter.logic_units) {
                            this.data_filter.logic_units = [];
                        }
                        this.normalizeDateExpressionUnits(this.data_filter);

                        if(this.data_filter.logic_units.length == 0 && this.add_blank) {
                            this.data_filter.logic_units.push({
                                db_column: null,
                                data_type:'string',
                                operator: null,
                                is_static: true,
                                show_options: false,
                                value:[],
                                modification: this.data_filter.logic_units_modification || 0,
                                operator_option_type: 'short',
                                tooltip_title: '',
                                column_removed_error: null
                            });
                        }

                        // Restore Match Any/All from filter_logic when filter is loaded (e.g. after navigating back)
                        this.inverted = this.isInverted(this.data_filter.filter_logic);
                        
                        // Reset the flag after processing
                        this.$nextTick(() => {
                            this.isUpdatingFromModel = false;
                        });
                    },
                    immediate: true,
                    deep: true
                },
                data_filter: {
                    handler(newVal) {
                        if(newVal) {
                            this.$emit('update:modelValue', JSON.parse(JSON.stringify(newVal)));
                            
                            // Handle database values loading
                            if (newVal.logic_units) {
                                for(var i = 0; i < newVal.logic_units.length; i++) {
                                    if(newVal.logic_units[i].db_column != null &&
                                        this.db_column_values[newVal.logic_units[i].db_column.value] == null)
                                        this.loadDatabaseValues(newVal.logic_units[i].db_column.value);
                                    
                                    // Update tooltip title when db_column changes
                                    if (newVal?.logic_units[i]?.db_column) {
                                        newVal.logic_units[i].tooltip_title = this.getColumnTitle(newVal.logic_units[i]);
                                    }
                                }
                                
                                // Reinitialize tooltips after updates
                                this.$nextTick(() => {
                                    this.initTooltips();
                                });
                            }
                        }
                    },
                    deep: true
                },
                source(old_pv, new_pv) {
                    this.loadDropdownColumns();
                },
                data_source_id(old_pv, new_pv) {
                    this.loadDropdownColumns();
                },
                static_db_columns: {
                    //Data filter watcher
                    handler(n, o) {
                        if (n) {
                            let formattedColumns = [];
                            
                            // If n is an object, transform it into array format
                            if (typeof n === 'object' && !Array.isArray(n)) {
                                formattedColumns = Object.entries(n).map(([value, text]) => ({
                                    value: value,
                                    text: text ? text.trim() : '', // Trim any extra whitespace
                                    category: null,
                                    subcategory: null
                                }));

                                // Process the columns to add categories and subcategories
                                formattedColumns = formattedColumns.map(col => {
                                    if (col.value.indexOf(".") != -1) {
                                        let parts = col.value.split(".");
                                        col.category = this.propercase(parts[0]);
                                        
                                        if (parts.length > 2) {
                                            col.subcategory = this.propercase(parts[1]);
                                            // For 3+ levels, join remaining parts with ›
                                            col.text = this.propercase(parts.slice(2).join(' › '));
                                        } else {
                                            col.text = this.propercase(parts[1]);
                                        }
                                    }
                                    return col;
                                });

                                // Sort columns to ensure proper nesting
                                formattedColumns.sort((a, b) => {
                                    // First sort by category
                                    if(a.value.indexOf(".") == -1 && b.value.indexOf(".") != -1)
                                        return -1;
                                    else if(a.value.indexOf(".") != -1 && b.value.indexOf(".") == -1)
                                        return 1;
                                    
                                    // If same category, sort by subcategory presence
                                    if(a.value.indexOf(".") != -1 && b.value.indexOf(".") != -1) {
                                        const aParts = a.value.split(".");
                                        const bParts = b.value.split(".");
                                        
                                        // If same category
                                        if(aParts[0] === bParts[0]) {
                                            // If one has subcategory and other doesn't, put the one without subcategory first
                                            if(aParts.length === 2 && bParts.length > 2) return -1;
                                            if(aParts.length > 2 && bParts.length === 2) return 1;
                                            
                                            // If both have 2 parts (category.field), sort by field name alphabetically
                                            if(aParts.length === 2 && bParts.length === 2) {
                                                return aParts[1].localeCompare(bParts[1]);
                                            }
                                            // If both have subcategories (3+ parts), sort by subcategory
                                            if(aParts.length > 2 && bParts.length > 2) {
                                                return aParts[1].localeCompare(bParts[1]);
                                            }
                                        }
                                        return aParts[0].localeCompare(bParts[0]);
                                    }
                                    
                                    return a.value.localeCompare(b.value);
                                });

                                // Add category and subcategory dividers
                                let current_category = null;
                                let current_subcategory = null;
                                let finalColumns = [];

                                for(let i = 0; i < formattedColumns.length; i++) {
                                    let col = formattedColumns[i];
                                    
                                    // Add category divider if category changes
                                    if(col && col.category && col.category !== current_category) {
                                        finalColumns.push({
                                            value: "DIVIDER-"+ col.category,
                                            category: col.category,
                                            text: "",
                                            subcategory: null
                                        });
                                        current_category = col.category;
                                        current_subcategory = null; // Reset subcategory when category changes
                                    }

                                    // Add subcategory divider if subcategory changes
                                    if(col.subcategory != null && col.subcategory !== current_subcategory) {

                                        let col_category = (col && col.category ? col.category : '');
                                        let col_subcategory = (col && col.subcategory ? col.subcategory : '');

                                        finalColumns.push({
                                            value: "DIVIDER-"+ col_category + "-" + col_subcategory,
                                            category: col_category,
                                            subcategory: col_subcategory,
                                            text: ""
                                        });

                                        current_subcategory = col_subcategory;
                                    }

                                    finalColumns.push(col);
                                }

                                this.db_columns = finalColumns;
                            } else {
                                // If n is already an array, use it directly
                                this.db_columns = this.getFormattedColumns();
                            }
                            
                            this.unfiltered_db_columns = JSON.parse(JSON.stringify(this.db_columns));
                            
                            // Re-validate all logic units to check for removed columns and update error messages
                            if (this.data_filter && this.data_filter.logic_units) {
                                this.data_filter.logic_units.forEach(unit => {
                                    if (unit.db_column && unit.db_column.value) {
                                        this.hasLogicUnitError(unit);
                                    }
                                });
                            }
                        } else {
                            this.db_columns = [];
                            this.unfiltered_db_columns = [];
                        }
                    },
                    immediate: true,
                    deep: true
                },
            },
            methods: {
                shouldShowClass(el) {
                    const options = this.getOperatorOptions(this.data_filter.logic_units[el]);
                    return options.length <= 5;
                },
                expandOperatorCategory(cat, expand) {
                    if (!cat) return false;
                    
                    const isExpanded = this.expanded_operator_categories.includes(cat);
                    const shouldExpand = expand === true || !isExpanded;

                    // Update state arrays immediately for reactive updates
                    if (shouldExpand && !this.expanded_operator_categories.includes(cat)) {
                        this.expanded_operator_categories.push(cat);
                    } else if (!shouldExpand) {
                        this.expanded_operator_categories = this.expanded_operator_categories.filter(c => c !== cat);
                    }

                    // Use $nextTick to ensure DOM updates happen after Vue's reactive updates
                    this.$nextTick(() => {
                        // Find all elements related to this category within the operator select
                        const categoryHeader = document.querySelector(`.operator-select div[data-category='${cat}']`);
                        if (!categoryHeader) return;

                        // Update category header
                        const categoryIcon = categoryHeader.querySelector('.fa-caret-right, .fa-caret-down');
                        if (categoryIcon) {
                            categoryIcon.classList.toggle('fa-caret-right', !shouldExpand);
                            categoryIcon.classList.toggle('fa-caret-down', shouldExpand);
                        }
                        categoryHeader.dataset.isexpanded = shouldExpand;

                        // Find and update all related operator options
                        const operatorOptions = document.querySelectorAll(`.operator-select div[data-category='${cat}'].operator-option`);
                        operatorOptions.forEach(option => {
                            option.style.display = shouldExpand ? "block" : "none";
                        });
                    });

                    return false;
                },

                getOptions(unit){
                    if(unit == null || unit.db_column == null || (unit.db_column && unit.db_column.value == ""))
                        return [];
                    else
                        return this.db_column_values[unit.db_column.value] || [];
                },
                getColumnTitle(col){
                    if(col == null || col.db_column == null)
                        return '';
                    
                    const { category, subcategory, text } = col.db_column;
                    let title = '';
                    
                    if(category != null && category != "") {
                        title += category + ": ";
                    }
                    if(subcategory != null && subcategory != "") {
                        title += subcategory + " › ";
                    }
                    title += text || '';
                    
                    return title;
                },
                getOperatorOptions(unit){
                    if(unit == null)
                        return this.unfiltered_operator_options;

                    let type = unit.operator_option_type;
                    if (type == 'full'){
                        return this.unfiltered_operator_options;
                    } else {
                        var data_type = 'string';
                        //Use the actual data type from the database
                        //Get the count of the column_type keys

                        if(Object.keys(this.column_types).length > 0 && unit.db_column && this.column_types[unit.db_column.value])
                            data_type = this.column_types[unit.db_column.value];
                        else if(unit.data_type && unit.data_type != 'string')
                            data_type = unit.data_type;
                        else if(unit.db_column && unit.db_column.text)
                            data_type = this.guessDataType(unit.db_column.text);

                        if(data_type == 'boolean' || data_type == 'bool'){
                            return [
                                { category: "", value: '=', text: 'Equals' },
                                { category: "", value: '<>', text: 'Does Not Equal' },
                                { category: "Common Operators", value: 'IS NULL', text: 'Is Blank' },
                                { category: "Common Operators", value: 'IS NOT NULL', text: 'Is Not Blank' }
                            ];
                        } else if(data_type == 'date' || data_type.indexOf('date') > -1 || data_type.indexOf('time') > -1){
                            return [
                                { category: "", value: '=', text: 'Equals' },
                                { category: "Date Operators", value: '>', text: 'Is After' },
                                { category: "Date Operators", value: '>=', text: 'Is On or After' },
                                { category: "Date Operators", value: '<', text: 'Is Before' },
                                { category: "Date Operators", value: '<=', text: 'Is On or Before' },
                            ];
                        } else if(data_type == 'number' || data_type.indexOf('float') > -1 || data_type.indexOf('int') > -1){
                            return [
                                { category: "", value: '=', text: 'Equals' },
                                { category: "Number Operators", value: '>', text: '>' },
                                { category: "Number Operators", value: '>=', text: '>=' },
                                { category: "Number Operators", value: '<', text: '<' },
                                { category: "Number Operators", value: '<=', text: '<=' },
                            ];
                        } else {
                            return [
                                { category: "", value: '=', text: 'Equals' },
                                { category: "", value: '<>', text: 'Does Not Equal' },
                                { category: "Common Operators", value: 'IS NULL', text: 'Is Blank' },
                                { category: "Common Operators", value: 'IS NOT NULL', text: 'Is Not Blank' },
                                { category: "Text Operators", value: 'LIKE', text: 'Contains' },
                            ];
                        }
                    }
                },
                guessDataType(col){
                    if(col){
                        col = col.toLowerCase();
                        //If it contains date, dte, utc, time, or timestamp, created, or updated
                        if((col.indexOf('date') > -1 && col.indexOf('consolidate') == -1 && col.indexOf('validate') == -1) || 
                            col.indexOf('dte') > -1 || col.indexOf('utc') > -1 ||
                            col.indexOf('time') > -1 || col.indexOf('timestamp') > -1 || col.indexOf('created') > -1 ||
                            col.indexOf('modified') > -1 || col.indexOf('updated') > -1)
                            return 'date';
                        //If it contains "is " or "has " or "flag"
                        else if(col.indexOf('is ') > -1 || col.indexOf('has ') > -1 || col.indexOf('flag') > -1
                            || col.indexOf('opt in') > -1 || col.indexOf('opt out') > -1|| col.indexOf('valid') > -1
                            || col.indexOf('can be') > -1 || col.indexOf('can have') > -1)
                            return 'boolean';
                        //If it contains "count" or "sum" or "avg" or "max" or "min" or amt or amount or rev or number
                        else if((col.indexOf('count') > -1 && col.indexOf('account') == -1) || col.indexOf('day') > -1 || col.indexOf('month') > -1
                            ||col.indexOf('year') > -1 ||  col.indexOf('sum') > -1 || col.indexOf('avg') > -1 ||
                            col.indexOf('max') > -1 || col.indexOf('min') > -1 || col.indexOf('amt') > -1 ||
                            col.indexOf('amount') > -1 || col.indexOf('rev') > -1 || col.indexOf('giving') > -1 ||
                            col.indexOf('total') > -1 || col.indexOf('number') > -1)
                            return 'number';
                        else
                            return 'string';
                    }
                    return 'string';
                },
                loadFullOperatorList(el){
                    this.data_filter.logic_units[el].operator_option_type = 'full';
                    
                    // Use $nextTick to ensure the DOM has been updated before reopening the dropdown
                    this.$nextTick(() => {
                        const operatorSelect = this.$refs.operatorSelect[el];
                        if (operatorSelect) {
                            operatorSelect.open = true;
                            this.handleOperatorOpen(el);
                        }
                    });
                },
                expandAllOperatorCategories() {
                    // Get all unique categories
                    const categories = [...new Set(this.unfiltered_operator_options
                        .filter(opt => opt.category)
                        .map(opt => opt.category))];
                        
                    // Expand all categories
                    this.expanded_operator_categories = categories;
                },
                
                handleOperatorOpen(el) {
                    if (this.data_filter.logic_units[el].operator_option_type === 'full') {
                        this.$nextTick(() => {
                            const options = document.querySelectorAll('.operator-select .suboption');
                            options.forEach(option => {
                                option.classList.add('show');
                            });
                        });
                    }
                },
                isFormValid() {
                    //Reset the error messages
                    for(var i = 0; i < this.data_filter.logic_units.length; i++)
                        this.errors.logic_units[i] = false;

                    //If there is only one logic unit, and has not column, operator, or value, just remove it.

                    if(this.data_filter.logic_units.length == 1) {
                        let unit = this.data_filter.logic_units[0];

                        //Check the column and operator first
                        if((unit.db_column == null || unit.db_column.value == "" ||
                            unit.operator == null || unit.operator.value == ""))
                            this.data_filter.logic_units = [];
                        //Now I can check the value since it can be blank if the operator is IS NULL or IS NOT NULL
                        else if(unit.operator.value != 'IS NULL' && unit.operator.value != 'IS NOT NULL' &&
                            (unit.value == null || unit.value.length == 0)){
                            this.data_filter.logic_units = [];
                        }

                    }


                    var form_is_valid = true;
                    for(var i = 0; i < this.data_filter.logic_units.length; i++) {
                        this.errors.logic_units[i] = this.hasLogicUnitError(this.data_filter.logic_units[i]);
                        if(this.errors.logic_units[i])
                            form_is_valid = false;
                    }

                    if(!form_is_valid)
                        this.$forceUpdate();

                    return form_is_valid;
                },
                setInverted() {
                    // console.log(this.inverted);
                    this.inverted = !this.inverted;

                    //Swap the AND and OR in the logic
                    var logic = this.data_filter.filter_logic;
                    if(logic == null)
                        return;

                    this.data_filter.filter_logic = logic.replace(/\bAND\b|\bOR\b/g, function(match) {
                        return match === "AND" ? "OR" : "AND";
                    });
                    // console.log(this.data_filter.filter_logic);

                },
                isInverted(stmt) {
                    if(stmt == null)
                        stmt = '';

                    stmt = stmt.toUpperCase().replaceAll("(", " ( ").replaceAll(")", " ) ");
                    const tokens = stmt.match(/[\w()]+|[^\w\s()+-]+/g);

                    //If it is only one, return false
                    if(tokens == null || tokens.length == 1)
                        return false;

                    //If it starts with a number, then I care about the second one
                    if(/^\d+$/.test(tokens[0]))
                        return tokens[1] === "OR";

                    //Only treat a top-level operator as the match type (ignore inner group operators)
                    var parensCount = 0;
                    for (let i = 0; i < tokens.length; i++) {
                        const token = tokens[i];

                        if (token === "(")
                          parensCount++;
                        else if (token === ")")
                          parensCount--;
                        else if (parensCount === 0 && (token === "OR" || token === "AND"))
                            return token === "OR";
                    }

                    //No top-level operator means a single group; default to Match All
                    return false;
                },
                updateModification(){
                    this.data_filter.logic_units.forEach(unit => {
                        unit.modification = this.data_filter.logic_units_modification
                    });

                },
                addEntryToValue(unit_index, entry){
                    if (this.data_filter.logic_units[unit_index] && this.data_filter.logic_units[unit_index].value && Array.isArray(this.data_filter.logic_units[unit_index].value)) {
                        this.data_filter.logic_units[unit_index].value.push(entry);
                    }
                    //Clear all search text
                    for(var i = 0; i < this.$refs.valueSelect.length; i++)
                        this.$refs.valueSelect[i].search = '';
                },
                handleEnter: function(map, vm) {
                   var self = this;
                    return {
                        ...map,
                        13: function(e) { //Enter Key

                            e.preventDefault();
                            if (vm.search && vm.search.length > 0) {
                                //Split the ID by - and get the last element
                                let id = vm.$el.id.split('-').pop();
                                self.addEntryToValue(Number(id), vm.search);
                            }
                        }
                    };
                },handleBlur(el) {
                    // Find the v-select component with the corresponding ID
                    const select = this.$refs.valueSelect.find(select => select.$el.id === `id-${el}`);

                    // Check if the select exists and has search text
                    if (select && select.search && select.search.trim().length > 0) {
                        // Add the entry using the existing method
                        this.addEntryToValue(Number(el), select.search.trim());
                    }
                },

                /**
                 * When AI (or backend) returns DATE_SUB/DATE_ADD in a unit value, show the date-comparison UI: show_options true, is_static false.
                 */
                normalizeDateExpressionUnits(dataFilter) {
                    if (!dataFilter?.logic_units) return;
                    dataFilter.logic_units.forEach(unit => {
                        const v = unit.value;
                        if (typeof v === 'string' && (v.includes('DATE_SUB') || v.includes('DATE_ADD'))) {
                            unit.show_options = true;
                            unit.is_static = false;
                        }
                    });
                },
                getBlankDataFilter() {
                    var data = {
                        filter_option: "custom",
                        filter_logic: '1',
                        filter_ui: 'simple',
                        logic_units_modification: false,
                        logic_error_msg: "",
                        logic_units: []
                    }

                    if(this.add_blank)
                        data.logic_units.push(
                            {
                                db_column: null,
                                data_type:'string',
                                operator: null,
                                is_static: true,
                                show_options: false,
                                value:[],
                                modification: (this.data_filter && this.data_filter.logic_units_modification) || 0,
                                operator_option_type: 'short',
                                tooltip_title: '',
                                column_removed_error: null
                            });
                    return data;
                },
                dateNumCalc(value) {
                    if(value == undefined || moment.isDate(value) || value.indexOf("DATE_SUB") == -1)
                        return value;
                    value = value.replace("DATE_SUB(CURRENT_DATE(), INTERVAL ", "");

                    var parts = value.split(" ");
                    return parts[0];

                    //num + " " + comparison + ")
                },
                dateComparisonCalc(value) {
                    if(value == undefined || moment.isDate(value) || value.indexOf("DATE_SUB") == -1)
                        return value;
                    value = value.replace("DATE_SUB(CURRENT_DATE(), INTERVAL ", "");

                    var parts = value.split(" ");
                    parts[1] = parts[1].replace(")", "");
                    return parts[1];

                    //num + " " + comparison + ")
                },
                isDate(data_type) {
                    if(data_type == undefined)
                        return false;

                    return data_type.indexOf('date') > -1 || data_type.indexOf('time') > -1;

                },
                typeOfSelection(unit) {
                    if(unit.is_static)
                        return '<i class="fa fa-font" ></i>';
                    else if(unit.show_options)
                        return '<i class="fas fa-calendar"></i>';
                    return '';
                },

                loadDropdownColumns() {
                    var _self = this;
                    var data = {
                      client: this.client.id,
                      include_trans: this.include_trans,
                      source: this.source,
                      data_source_id: this.data_source_id
                    };
                    //Only show loading if it is actully loading the columns
                    if(this.static_db_columns == null || this.static_db_columns.length == 0)
                        this.is_loading = true;

                    window.axios.post('/api/bigquery/get_db_columns', data)
                      .then(response => {
                        //If there are static columns, I only need this for the data types
                        if(!_self.static_db_columns || (_self.static_db_columns.length == 0 && response.data.columns.length > 0)) {
                            // Get current unit column values
                            const currentUnitColumns = new Set();
                            if (this.data_filter && this.data_filter.logic_units) {
                                this.data_filter.logic_units.forEach(unit => {
                                    if (unit.db_column && unit.db_column.value) {
                                        currentUnitColumns.add(unit.db_column.value);
                                    }
                                });
                            }

                            // Filter columns based on hidden field pattern
                            var cols = response.data.columns.filter((col) => {
                                const isHiddenField = /(?:^|\.)_/.test(col.value);
                                if (isHiddenField) {
                                    // If it's a hidden field, only keep it if it's in current units
                                    return currentUnitColumns.has(col.value);
                                }
                                return true;
                            });

                            var formatted_cols = [];
                            var current_category = null;
                            var current_subcategory = null;

                            // Store existing db_column values that don't match API response
                            const existingColumns = new Map();
                            if (this.data_filter && this.data_filter.logic_units) {
                                this.data_filter.logic_units.forEach(unit => {
                                    if (unit.db_column && unit.db_column.value) {
                                        existingColumns.set(unit.db_column.value, unit.db_column);
                                    }
                                });
                            }

                            // Sort columns to ensure proper nesting
                            cols.sort((a, b) => {
                                // First sort by category
                                if(a.value.indexOf(".") == -1 && b.value.indexOf(".") != -1)
                                    return -1;
                                else if(a.value.indexOf(".") != -1 && b.value.indexOf(".") == -1)
                                    return 1;
                                
                                // If same category, sort by subcategory presence
                                if(a.value.indexOf(".") != -1 && b.value.indexOf(".") != -1) {
                                    const aParts = a.value.split(".");
                                    const bParts = b.value.split(".");
                                    
                                    // If same category
                                    if(aParts[0] === bParts[0]) {
                                        // If one has subcategory and other doesn't, put the one without subcategory first
                                        if(aParts.length === 2 && bParts.length > 2) return -1;
                                        if(aParts.length > 2 && bParts.length === 2) return 1;
                                        
                                        // If both have 2 parts (category.field), sort by field name alphabetically
                                        if(aParts.length === 2 && bParts.length === 2) {
                                            return aParts[1].localeCompare(bParts[1]);
                                        }
                                        // If both have subcategories (3+ parts), sort by subcategory
                                        if(aParts.length > 2 && bParts.length > 2) {
                                            return aParts[1].localeCompare(bParts[1]);
                                        }
                                    }
                                    return aParts[0].localeCompare(bParts[0]);
                                }
                                
                                return a.value.localeCompare(b.value);
                            });

                            // Create a Set of API response values for quick lookup
                            const apiValues = new Set(cols.map(col => col.value));

                            for(let i = 0; i < cols.length; i++) {
                                let col = cols[i];
                                let category = null;
                                let subcategory = null;
                                let text = col.text;

                                if(col.value.indexOf(".") != -1) {
                                    let parts = col.value.split(".");
                                    category = this.propercase(parts[0]);
                                    
                                    if(parts.length > 2) {
                                        subcategory = this.propercase(parts[1]);
                                        // For 3+ levels, join remaining parts with ›
                                        text = this.propercase(parts.slice(2).join(' › '));
                                    } else {
                                        text = this.propercase(parts[1]);
                                    }

                                    // Add category divider if category changes
                                    if(category != current_category) {
                                        formatted_cols.push({
                                            value: "DIVIDER-"+ category,
                                            category: category,
                                            text: "",
                                            subcategory: null
                                        });
                                        current_subcategory = null; // Reset subcategory when category changes
                                    }

                                    // Add subcategory divider if subcategory changes
                                    if(subcategory && subcategory != current_subcategory) {
                                        formatted_cols.push({
                                            value: "DIVIDER-"+ category + "-" + subcategory,
                                            category: category,
                                            subcategory: subcategory,
                                            text: ""
                                        });
                                    }
                                }

                                current_category = category;
                                current_subcategory = subcategory;

                                const isHiddenField = /(?:^|\.)_/.test(col.value);
                                formatted_cols.push({
                                    value: col.value,
                                    text: text,
                                    category: category,
                                    subcategory: subcategory,
                                    if_column_matched: isHiddenField ? true : apiValues.has(col.value),
                                    if_sql_value: this.isSqlValue(col.value)
                                });
                            }

                            // Add any existing columns that weren't in the API response
                            existingColumns.forEach((existingCol, value) => {
                                if (!formatted_cols.some(col => col.value === value)) {
                                    const isHiddenField = /(?:^|\.)_/.test(value);
                                    formatted_cols.push({
                                        value: value,
                                        text: existingCol.text || value,
                                        category: existingCol.category || '',
                                        subcategory: existingCol.subcategory || null,
                                        if_column_matched: isHiddenField ? true : false,
                                        if_sql_value: this.isSqlValue(value)
                                    });
                                }
                            });

                            // Update if_column_matched and if_sql_value for existing columns
                            if (this.data_filter && this.data_filter.logic_units) {
                                this.data_filter.logic_units.forEach(unit => {
                                    if (unit.db_column && unit.db_column.value) {
                                        const isHiddenField = /(?:^|\.)_/.test(unit.db_column.value);
                                        unit.db_column.if_column_matched = isHiddenField ? true : apiValues.has(unit.db_column.value);
                                        unit.db_column.if_sql_value = this.isSqlValue(unit.db_column.value);
                                        
                                        // Re-validate to check for removed columns and update error messages
                                        this.hasLogicUnitError(unit);
                                    }
                                });
                            }

                            _self.db_columns = formatted_cols;
                            _self.unfiltered_db_columns = JSON.parse(JSON.stringify(formatted_cols));
                        }
                        //Save the types...
                        _self.column_types = {};
                        let only_strings = true;
                        for(let i = 0; i < response.data.columns.length; i++) {
                            let col = response.data.columns[i];
                            _self.column_types[col.value] = col.type;
                            if(col.type != 'string')
                                only_strings = false;
                        }
                        //If it is only strings, it is likely a file upload so I'll need to sniff the data types
                        if(only_strings)
                            _self.column_types = {};

                        _self.is_loading = false;
                      });
                },
                shouldShowValues(operator) {
                    //If the logic operator is an object
                    if(operator == null)
                        return true; // Show input field when operator is null so user can see placeholder
                        
                    if(typeof operator == "object")
                        operator = operator.value;

                    return operator != 'IS NULL' && operator != 'IS NOT NULL';
                },
                shouldShowSelect(unit) {
                    if(unit == null || unit.operator == null)
                        return false;
                    let should_show = (unit.operator.value=='=' || unit.operator.value=='<>')  && (unit.data_type == 'string' || unit.data_type == 'boolean' || unit.data_type == 'bool');
                    //Make it an array if it was an individually entered item in the textfield
                    let val = unit.value;
                    if (should_show && !Array.isArray(val) && val != null && (typeof val !== "string" || val.trim() != ""))
                        unit.value = [val];
                    return should_show;
                },
                shouldShowDate(unit) {
                    if(unit == null || unit.data_type == null || unit.operator == null)
                        return false;

                    //If the operator is "IN_" then return false
                    if(unit.operator.value && unit.operator.value.indexOf('IN_') != -1)
                        return false;

                    let is_date = false;
                    if(unit.data_type == 'string' && unit.db_column && unit.db_column.text)
                        is_date= this.guessDataType(unit.db_column.text) == 'date';
                    else
                        is_date = unit.data_type.indexOf('date') > -1 || unit.data_type.indexOf('time') > -1;

                    //If it is a date and the unit.value  isn't in a date format, set it to a blank string
                    if(is_date && unit.value != null && Array.isArray(unit.value))
                        unit.value = "";

                    return is_date;
                },
                hasLogicUnitError(logic) {
                    //If the logic operator is an object
                    var operator;
                    if(logic){
                        if(logic.operator != null && typeof logic.operator == "object")
                            operator = logic.operator.value;

                        if(logic.db_column == null || operator == null || 
                            (logic.db_column && logic.db_column.value == "") || operator == "" ||
                            ( logic.value == "" && operator && operator.indexOf("NULL") == -1)){
                                return true;
                        }

                        //If the database column is no longer available in the source table
                        if(logic.db_column && this.unfiltered_db_columns != null && this.unfiltered_db_columns.length > 0 && !this.unfiltered_db_columns.find(obj => obj.value === logic.db_column.value) ) {                            
                            // Set a specific error message for removed columns
                            logic.column_removed_error = `A column (${logic.db_column.value}) has been removed from the latest data refresh. Please update this field.`;
                            
                            // Clear the column data
                            logic.db_column.value = "";
                            logic.db_column.text = "";
                            logic.db_column.category = "";
                            logic.db_column.subcategory = "";
                            return true;
                        } else {
                            // Clear the error message if column is available
                            logic.column_removed_error = null;
                        }
                    }

                    return false;
                },
                loadDatabaseValues(db_column) {

                    if(db_column == undefined || db_column == null || db_column == "")
                        return;

                    var data = {
                      client: this.client,
                      source: this.source,
                      column: db_column,
                      limit: 1000,
                      data_source_id: this.data_source_id,
                      staging_table: (this.static_db_columns != null),
                    };

                    var _self = this;

                    this.db_column_values[db_column] = [];
                    this.is_loading = true;

                    window.axios.post('/api/bigquery/get_samples', data)
                      .then(response => {
                        //Remove the null value Kevin
                        for(var i = response.data.samples.length - 1; i >= 0; i--)
                            if(response.data.samples[i].name == null)
                                response.data.samples.splice(i, 1);

                        response.data.samples.sort((a, b) => (a.name > b.name ) ? 1 : -1);

                        if(response.data.samples.length > 0){
                            let value_list = [];
                            response.data.samples.forEach((value) =>{
                                if (value.name && value.name.trim() != ''){
                                    value_list.push({
                                        category: '',
                                        text: value.name,
                                        value: value.name
                                    })
                                }

                            })
                            _self.db_search[db_column] = (value_list.length >= 999);
                            _self.db_column_values[db_column] = value_list;
                            _self.unfiltered_db_column_values[db_column] = value_list;
                        } else{
                            _self.db_search[db_column] = false
                            _self.db_column_values[db_column] = [
                                {name: '** All values are blank **'}
                            ];
                            _self.unfiltered_db_column_values[db_column] = [
                                {name: '** All values are blank **'}
                            ];
                        }

                        _self.is_loading = false;
                        _self.$forceUpdate();
                    });
                },
                addLogicUnit(index) {
                    this.data_filter.logic_units.push(
                        {
                            db_column: null,
                            data_type:'string',
                            operator: null,
                            value:[],
                            is_static: true,
                            show_options: false,
                            modification: this.data_filter.logic_units_modification,
                            operator_option_type: 'short',
                            tooltip_title: '',
                            column_removed_error: null
                        });

                    this.errors.logic_units.push(false);

                    //Now update the logic statement

                    //Get the nested units;
                    //Loop through and reassemble the logic statement
                    var units = this.nested_units;
                    var stmt = "";

                    if(units != null)
                        for(var i =0; i < units.length; i++){
                            var logic = "";
                            for(var j = 0; j < units[i].length; j++){
                                if(j > 0)
                                    logic += ((this.inverted)? " AND " : " OR ");
                                logic += (units[i][j]+1);
                            }
                            if(index == i)
                                logic += ((this.inverted)? " AND " : " OR ") + this.data_filter.logic_units.length;

                            stmt += "(" + logic + ")"
                            if(i < units.length-1)
                                stmt += ((this.inverted)? " OR " : " AND ");
                        }

                    //If it is the "Add Condition" it will just append to the end
                    if(index == -1)
                        //If this is the first unit
                        if(this.data_filter.logic_units.length == 1)
                            stmt = "1";
                        else
                            stmt += ((this.inverted)? " OR " : " AND ") + this.data_filter.logic_units.length;

                    this.data_filter.filter_logic = stmt;

                },
                removeLogicUnit(index) {
                    var units = this.nested_units;
                    for(var i =0; i < units.length; i++)
                        for(var j = 0; j < units[i].length; j++)
                            if(units[i][j] == index) {
                                units[i].splice(j,1);

                                //Remove empty arrays
                                if(units[i].length == 0)
                                    units.splice(i, 1);

                                i = units.length;
                                break;
                            }

                    this.data_filter.logic_units.splice(index,1);
                    this.errors.logic_units.splice(index,1);

                    //If it is empty, just save the logic statement and be done
                    if(this.data_filter.logic_units.length == 0) {
                        this.data_filter.filter_logic = "";
                        return;
                    }

                    //Remake the logic

                    var stmt = "";
                    for(var i =0; i < units.length; i++){
                        var logic = "";
                        for(var j = 0; j < units[i].length; j++){
                            if(j > 0)
                                logic += ((this.inverted)? " AND " : " OR ");
                            //Need to subtract one from all elements above the removed one to reset the index
                            logic += (units[i][j]+(index > units[i][j] ? 1 : 0));
                        }

                        stmt += "(" + logic + ")"
                        if(i < units.length-1)
                            stmt += ((this.inverted)? " OR " : " AND ");
                    }

                    this.data_filter.filter_logic = stmt;

                    //The showCustomError method will handle the rest

                },
                updateOperator(unit) {
                    if(unit.operator == null) return;

                    // Clear column removed error when operator changes
                    if(unit.column_removed_error) {
                        unit.column_removed_error = null;
                    }

                    let type = 'string';

                    if(unit.data_type && unit.data_type != 'string')
                        type = unit.data_type;
                    else if(unit.db_column){
                        if(Object.keys(this.column_types).length > 0 && this.column_types[unit.db_column.value])
                            type = this.column_types[unit.db_column.value];
                        else
                            type = this.guessDataType(unit.db_column.text);
                    }
                    if(unit.operator.category.indexOf("Number") > -1 || type == 'number'){
                        unit.data_type = 'float';
                        unit.db_column.type = 'float';
                    }
                    else if(unit.operator.category.indexOf("Date") > -1 || type == 'date'){
                        unit.data_type = 'datetime';
                        unit.db_column.type = 'datetime';
                    }
                    else if(unit.db_column.type == 'bool' || type == 'boolean' ){
                        unit.data_type = 'bool';
                        unit.db_column.type = 'bool';
                    }
                    else {
                        unit.data_type = 'string';
                        unit.db_column.type = 'string';
                    }

                    // Clear previous IN_ selections if switching between different IN_ operators
                    const newOperator = unit.operator.value;
                    const oldOperator = unit._previousOperator;
                    
                    // Store current operator for next comparison
                    unit._previousOperator = newOperator;

                    // If operator switched to a non-comparison type, clear validation error and selections
                    if (!this.isFileOperator(newOperator)) {
                        unit.validation_error = '';
                        unit.selected_file = null;
                        unit.selected_column = null;
                    }

                    // If switching between different IN_ operators, clear selections
                    if (newOperator.includes('IN_') && oldOperator && oldOperator.includes('IN_') && newOperator !== oldOperator) {
                        unit.selected_file = null;
                        unit.selected_column = null;
                        unit.value = null;
                    }

                    if(unit.operator != undefined &&
                        (unit.operator.value == 'REGEXP_CONTAINS' || unit.operator.value.indexOf("IN") >= 0
                            || unit.operator.value == "LIKE" || unit.operator.value.indexOf('NULL') >= 0 )){
                        unit.is_static = true;
                        unit.show_options = false;

                        if(typeof unit.value === 'object' && unit.value !== null)
                            unit.value = unit.value.text;

                        if(unit.value === undefined){
                            unit.value  = null;
                        }
                    }

                    // Reset file selection when operator changes
                    if (unit.operator.value && unit.operator.value.indexOf('IN_') != -1) {
                        // Only load files if they haven't been loaded yet
                        if (!this.files_loaded) {
                            this.loadAvailableFiles();
                        }
                        unit.selected_file = null;
                        unit.selected_column = null;
                        this.file_columns = [];
                        
                        // Clear any existing validation error when switching operators
                        unit.validation_error = null;
                    }

                    // Validate file ID column if this is a file operator and we have all required fields
                    if (this.isFileOperator(unit.operator) && 
                        unit.db_column && 
                        unit.selected_file && 
                        unit.selected_column) {
                        // Find the index of this unit to pass to validateFileIDColumn
                        const index = this.data_filter.logic_units.findIndex(u => u === unit);
                        if (index !== -1) {
                            this.$nextTick(() => {
                                this.validateFileIDColumn(index);
                            });
                        }
                    }
                },

                updateDateValue(index, unit) {
                    var num = $(".date-comparison-num[data-index='" + index + "']").val();
                    var comparison = $(".date-comparison-select[data-index='" + index + "']").val();

                    unit.value = "DATE_SUB(CURRENT_DATE(), INTERVAL " + num + " " + comparison + ")" ;
                },
                expandCategory(cat, expand) {
                    if (!cat) return false;
                    
                    const isExpanded = this.expanded_categories.includes(cat);
                    const shouldExpand = expand === true || !isExpanded;

                    // Update state arrays immediately for reactive updates
                    if (shouldExpand && !this.expanded_categories.includes(cat)) {
                        this.expanded_categories.push(cat);
                    } else if (!shouldExpand) {
                        this.expanded_categories = this.expanded_categories.filter(c => c !== cat);
                        // Remove all subcategories of this category
                        this.expanded_subcategories = this.expanded_subcategories.filter(sc => !sc.startsWith(cat + '-'));
                    }

                    // Use $nextTick to ensure DOM updates happen after Vue's reactive updates
                    this.$nextTick(() => {
                        // Find all elements related to this category
                        const categoryHeader = document.querySelector(`div[data-category='${cat}']`);
                        if (!categoryHeader) return;

                        // Update category header
                        const categoryIcon = categoryHeader.querySelector('.fa-caret-right, .fa-caret-down');
                        if (categoryIcon) {
                            categoryIcon.classList.toggle('fa-caret-right', !shouldExpand);
                            categoryIcon.classList.toggle('fa-caret-down', shouldExpand);
                        }
                        categoryHeader.dataset.isexpanded = shouldExpand;

                        // Find and update all related subcategory headers
                        const subcategoryHeaders = document.querySelectorAll(`div[data-subcategory='${cat}'].subcategory-header`);
                        subcategoryHeaders.forEach(header => {
                            header.style.display = shouldExpand ? "block" : "none";
                            if (!shouldExpand) {
                                header.dataset.isexpanded = "false";
                                const subcategoryIcon = header.querySelector('.fa-caret-right, .fa-caret-down');
                                if (subcategoryIcon) {
                                    subcategoryIcon.classList.add('fa-caret-right');
                                    subcategoryIcon.classList.remove('fa-caret-down');
                                }
                            }
                        });
                    });

                    return false;
                },
                expandSubcategory(cat, subcat, expand) {
                    if (!cat || !subcat) return false;

                    const subcategoryKey = `${cat}-${subcat}`;
                    const isExpanded = this.expanded_subcategories.includes(subcategoryKey);
                    const shouldExpand = expand === true || !isExpanded;

                    // Update state array immediately for reactive updates
                    if (shouldExpand && !this.expanded_subcategories.includes(subcategoryKey)) {
                        this.expanded_subcategories.push(subcategoryKey);
                    } else if (!shouldExpand) {
                        this.expanded_subcategories = this.expanded_subcategories.filter(sc => sc !== subcategoryKey);
                    }

                    // Use $nextTick to ensure DOM updates happen after Vue's reactive updates
                    this.$nextTick(() => {
                        const header = document.querySelector(`div[data-subcategory='${cat}'][data-subcategory-name='${subcat}']`);
                        if (!header) return;

                        // Update header
                        const icon = header.querySelector('.fa-caret-right, .fa-caret-down');
                        if (icon) {
                            icon.classList.toggle('fa-caret-right', !shouldExpand);
                            icon.classList.toggle('fa-caret-down', shouldExpand);
                        }
                        header.dataset.isexpanded = shouldExpand;

                        // Find and update all options under this subcategory
                        const options = document.querySelectorAll(`div[data-subcategory='${cat}'][data-subcategory-name='${subcat}'] + div.suboption`);
                        options.forEach(option => {
                            option.style.display = shouldExpand ? "block" : "none";
                        });
                    });

                    return false;
                },
                isSubcategoryVisible(category, subcategory) {
                    // On initial load, subcategory should only be visible if its parent category is expanded
                    // If the category is not expanded, hide all its subcategories
                    return this.expanded_categories.includes(category);
                },
                setEditingIndex(index){
                    this.editing_index = index;
                },
                searchOptions(search, loading){
                    if (!this.data_filter.logic_units[this.editing_index].db_column) {
                        return;
                    }
                    let column_name = this.data_filter.logic_units[this.editing_index].db_column.value;

                    if(!this.db_search[column_name]){
                        if(this.unfiltered_db_column_values[column_name])
                            this.db_column_values[column_name] = this.unfiltered_db_column_values[column_name].filter((value) => value.text.toLowerCase().includes(search.toLowerCase()));
                        else
                            this.db_column_values[column_name] = [];

                        this.is_loading = false;
                        this.$forceUpdate();
                    } else{
                        //Set the "Searching" notification
                        this.is_searching = true;
                        this.db_column_values[column_name] = [];
                        this.$forceUpdate();

                        var data = {
                            client: this.client,
                            source: this.source,
                            column: column_name,
                            limit: 1000,
                            data_source_id: this.data_source_id,
                            staging_table: (this.static_db_columns != null),
                            search: search
                        };

                        window.axios.post('/api/bigquery/get_samples', data)
                        .then(response => {
                            var db_values = [];
                            //Remove the null value
                            for(var i = response.data.samples.length - 1; i >= 0; i--){
                                if(response.data.samples[i].name == null)
                                    response.data.samples.splice(i, 1);
                                else {
                                    db_values.push(response.data.samples[i].name);
                                }
                            }
                            db_values.sort((a, b) => (a.name > b.name ) ? 1 : -1);
                            this.is_searching = false;
                            this.db_column_values[column_name] = db_values;
                            this.$forceUpdate();
                        });
                    }
                },
                fetchOptions(search, loading) {
                    //Reset the array
                    this.db_columns = JSON.parse(JSON.stringify(this.unfiltered_db_columns));

                    if(search == "") return;
                    this.is_loading = true;

                    // Tokenize search so "First Gift Date" matches giving_summary.first_gift.date (each word can be in category/subcategory/text)
                    const searchTokens = search.toLowerCase().trim().split(/\s+/).filter(Boolean);

                    //Look at each column
                    for(var i = this.db_columns.length-1; i >= 0 ; i--) {
                        const item = this.db_columns[i];
                        
                        // Skip SQL value columns
                        if(item.if_sql_value) {
                            this.db_columns.splice(i, 1);
                            continue;
                        }
                        
                        // Build one searchable string from category, subcategory, text, and raw value (e.g. "giving summary first gift date")
                        const searchableParts = [item.category, item.subcategory, item.text, item.value].filter(Boolean);
                        const searchableText = searchableParts.join(' ').toLowerCase().replace(/[._]/g, ' ');

                        // Keep item if every search token appears somewhere in the combined searchable string, or if it's a divider
                        const matchesSearch = searchTokens.length === 0 || searchTokens.every(token => searchableText.indexOf(token) !== -1);
                        if (!matchesSearch && item.text !== "") {
                            this.db_columns.splice(i, 1);
                        }
                    }

                    //Get the remaining categories and subcategories
                    var cats = [];
                    var subcats = new Map(); // Map to track subcategories and their matching options
                    
                    for(var i = 0; i < this.db_columns.length; i++) {
                        const item = this.db_columns[i];
                        if(item.category != null && item.text != "") {
                            if(!cats.includes(item.category)) {
                                cats.push(item.category);
                            }

                            // Track subcategories that have matching options
                            if(item.subcategory) {
                                const key = `${item.category}-${item.subcategory}`;
                                if(!subcats.has(key)) {
                                    subcats.set(key, false);
                                }
                                subcats.set(key, true);
                            }
                        }
                    }

                    //Remove subcategory headers that have no matching options
                    for(var i = this.db_columns.length-1; i >= 0 ; i--) {
                        const item = this.db_columns[i];
                        if(item.text == "" && item.subcategory) {
                            const key = `${item.category}-${item.subcategory}`;
                            if(!subcats.get(key)) {
                                this.db_columns.splice(i, 1);
                            }
                        }
                    }

                    //Remove category headers that have no matching options
                    for(var i = this.db_columns.length-1; i >= 0 ; i--) {
                        const item = this.db_columns[i];
                        if(item.text == "" && item.category != null && !cats.includes(item.category)) {
                            this.db_columns.splice(i, 1);
                        }
                    }

                    //Expand the categories and subcategories
                    for(var i = 0; i < cats.length; i++) {
                        this.expandCategory(cats[i], true);
                        // Find and expand all subcategories for this category
                        subcats.forEach((hasMatches, key) => {
                            const [category, subcategory] = key.split('-');
                            if (category === cats[i] && hasMatches) {
                                this.expandSubcategory(category, subcategory, true);
                            }
                        });
                    }

                    this.is_loading = false;
                    return true;
                },
                fetchOperators(search, loading) {
                    //Reset the array
                    this.operator_options = JSON.parse(JSON.stringify(this.unfiltered_operator_options));

                    if(search == "") {
                        // Expand all categories by default when no search
                            this.expanded_operator_categories = [...new Set(this.operator_options
                                .filter(opt => opt.category)
                                .map(opt => opt.category))];
                        return;
                    }

                    //Look at each operator
                    for(var i = this.operator_options.length-1; i >= 0 ; i--) {
                        //If the search string isn't in the text or the category
                        if(this.operator_options[i].text.toLowerCase().indexOf(search.toLowerCase()) == -1
                            && (this.operator_options[i].category == null
                            || this.operator_options[i].category.toLowerCase().indexOf(search.toLowerCase()) == -1)
                            && this.operator_options[i].text != "" ) //And not a category divider
                            this.operator_options.splice(i, 1);
                    }

                    //Get the remaining categories
                    var cats = [];
                    for(var i = 0; i < this.operator_options.length; i++)
                        if(this.operator_options[i].category != null && !cats.includes(this.operator_options[i].category) && this.operator_options[i].text != "")
                            cats.push(this.operator_options[i].category);

                    //Expand the categories that have matches
                    this.expanded_operator_categories = cats;

                    this.is_loading = false;
                    return true;
                },
                initTooltips() {
                    this.$nextTick(() => {
                        try {
                            const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');
                            [...tooltipTriggerList].forEach(tooltipTriggerEl => {
                                try {
                                    // Check if Bootstrap is available
                                    if (!window.bootstrap || !window.bootstrap.Tooltip) {
                                        console.warn('Bootstrap Tooltip is not available');
                                        return;
                                    }

                                    // Dispose any existing tooltip
                                    const existingTooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                                    if (existingTooltip) {
                                        existingTooltip.dispose();
                                    }

                                    // Only create new tooltip if element is valid
                                    if (tooltipTriggerEl && tooltipTriggerEl.getAttribute('data-bs-original-title')) {
                                        new window.bootstrap.Tooltip(tooltipTriggerEl, {
                                            trigger: 'hover',
                                            html: true,
                                            container: 'body'
                                        });
                                    }
                                } catch (tooltipError) {
                                    console.warn('Error initializing tooltip:', tooltipError);
                                }
                            });
                        } catch (error) {
                            console.warn('Error in initTooltips:', error);
                        }
                    });
                },
                shouldShowOption(category, subcategory) {
                    let classes = [];
                    
                    if (!category) {
                        classes.push('show');
                    } else {
                        classes.push('category-option');
                        const categoryExpanded = this.expanded_categories.includes(category);
                        if (!categoryExpanded) return classes.join(' ');
                        
                        if (!subcategory) {
                            classes.push('show');
                        } else {
                            classes.push('subcategory-option');
                            const subcategoryKey = `${category}-${subcategory}`;
                            if (this.expanded_subcategories.includes(subcategoryKey)) {
                                classes.push('show');
                            }
                        }
                    }
                    
                    return classes.join(' ');
                },
                handleHover(event) {
                    // Remove selected and highlight classes from all options
                    const allOptions = document.querySelectorAll('.vs__dropdown-option');
                    allOptions.forEach(option => {
                        option.classList.remove('vs__dropdown-option--selected', 'vs__dropdown-option--highlight');
                    });
                },
                handleOperatorHover(event) {
                    // Remove selected and highlight classes from all options
                    const allOptions = document.querySelectorAll('.vs__dropdown-option');
                    allOptions.forEach(option => {
                        option.classList.remove('vs__dropdown-option--selected', 'vs__dropdown-option--highlight');
                    });
                },
                getFormattedColumns() {
                    if(this.static_db_columns == null)
                        return this.db_columns;

                    var formatted_cols = [];
                    var current_category = null;
                    var current_subcategory = null;

                    // Sort columns to ensure proper nesting
                    this.static_db_columns.sort((a, b) => {
                        // First sort by category
                        if(a.value.indexOf(".") == -1 && b.value.indexOf(".") != -1)
                            return -1;
                        else if(a.value.indexOf(".") != -1 && b.value.indexOf(".") == -1)
                            return 1;
                        
                        // If same category, sort by subcategory presence
                        if(a.value.indexOf(".") != -1 && b.value.indexOf(".") != -1) {
                            const aParts = a.value.split(".");
                            const bParts = b.value.split(".");
                            
                            // If same category
                            if(aParts[0] === bParts[0]) {
                                // If one has subcategory and other doesn't, put the one without subcategory first
                                if(aParts.length === 2 && bParts.length > 2) return -1;
                                if(aParts.length > 2 && bParts.length === 2) return 1;
                                
                                // If both have 2 parts (category.field), sort by field name alphabetically
                                if(aParts.length === 2 && bParts.length === 2) {
                                    return aParts[1].localeCompare(bParts[1]);
                                }
                                // If both have subcategories (3+ parts), sort by subcategory then rest
                                if(aParts.length > 2 && bParts.length > 2) {
                                    return aParts[1].localeCompare(bParts[1]);
                                }
                            }
                            return aParts[0].localeCompare(bParts[0]);
                        }
                        
                        return a.value.localeCompare(b.value);
                    });

                    for(let i = 0; i < this.static_db_columns.length; i++) {
                        let col = this.static_db_columns[i];
                        let category = null;
                        let subcategory = null;
                        let text = col.text;

                        if(col.value.indexOf(".") != -1) {
                            let parts = col.value.split(".");
                            category = this.propercase(parts[0]);
                            
                            if(parts.length > 2) {
                                subcategory = this.propercase(parts[1]);
                                // For 3+ levels, join remaining parts with ›
                                text = this.propercase(parts.slice(2).join(' › '));
                            } else {
                                text = this.propercase(parts[1]);
                            }

                            // Add category divider if category changes
                            if(category != current_category) {
                                formatted_cols.push({
                                    value: "DIVIDER-"+ category,
                                    category: category,
                                    text: "",
                                    subcategory: null
                                });
                                current_subcategory = null; // Reset subcategory when category changes
                            }

                            // Add subcategory divider if subcategory changes
                            if(subcategory && subcategory != current_subcategory) {
                                formatted_cols.push({
                                    value: "DIVIDER-"+ category + "-" + subcategory,
                                    category: category,
                                    subcategory: subcategory,
                                    text: ""
                                });
                            }
                        }

                        current_category = category;
                        current_subcategory = subcategory;

                        formatted_cols.push({
                            value: col.value,
                            text: text,
                            category: category,
                            subcategory: subcategory
                        });
                    }

                    return formatted_cols;
                },
                isSqlValue(value) {
                    if (!value) return false;
                    
                    // Check for common SQL patterns
                    const sqlPatterns = [
                        /\b(IF|CASE|WHEN|THEN|ELSE|END)\b/i,  // IF/CASE statements
                        /\b(SELECT|FROM|WHERE|GROUP BY|ORDER BY|HAVING|JOIN|LEFT|RIGHT|INNER|OUTER)\b/i,  // SQL keywords
                        /\b(COUNT|SUM|AVG|MAX|MIN)\s*\(/i,  // Aggregate functions
                        /\b(AND|OR|NOT|IN|EXISTS|BETWEEN|LIKE)\b/i,  // SQL operators
                        /\b(IS NULL|IS NOT NULL)\b/i,  // NULL checks
                        /[<>]=?|!=|=/,  // Comparison operators
                        /\(.*\)/,  // Parentheses (function calls or subqueries)
                        /\b(CURRENT_DATE|CURRENT_TIMESTAMP|NOW)\b/i,  // Current date/time functions
                        /\b(COALESCE|NULLIF|IFNULL)\b/i  // NULL handling functions
                    ];

                    //if(sqlPatterns.some(pattern => pattern.test(value)))
                    //    console.log(value);

                    return sqlPatterns.some(pattern => pattern.test(value));
                },
                handleColumnDisplayOpen(el) {
                    // Reset expanded states
                    this.expanded_categories = [];
                    this.expanded_subcategories = [];

                    // First handle the selected column's category/subcategory
                    const selectedColumn = this.data_filter.logic_units[el].db_column;
                    if (selectedColumn && selectedColumn.category) {
                        // Don't expand the selected category initially
                        this.expanded_categories = [];
                        if (selectedColumn.subcategory) {
                            this.expanded_subcategories = [];
                        }
                    }

                    // Ensure all categories and subcategories are collapsed
                    this.$nextTick(() => {
                        // Find all category headers and collapse them
                        const categoryHeaders = document.querySelectorAll('.category-header');
                        categoryHeaders.forEach(header => {
                            const category = header.dataset.category;
                            if (category) {
                                const icon = header.querySelector('.fa-caret-right, .fa-caret-down');
                                if (icon) {
                                    icon.classList.add('fa-caret-right');
                                    icon.classList.remove('fa-caret-down');
                                }
                                header.dataset.isexpanded = "false";
                            }
                        });

                        // Find all subcategory headers and collapse them
                        const subcategoryHeaders = document.querySelectorAll('.subcategory-header');
                        subcategoryHeaders.forEach(header => {
                            const icon = header.querySelector('.fa-caret-right, .fa-caret-down');
                            if (icon) {
                                icon.classList.add('fa-caret-right');
                                icon.classList.remove('fa-caret-down');
                            }
                            header.dataset.isexpanded = "false";
                        });
                    });
                },
                shouldShowFileSelection(unit) {
                    if (!unit || !unit.operator) return false;
                    
                    const operator = typeof unit.operator === 'object' ? unit.operator.value : unit.operator;
                    return operator && operator.indexOf('IN_') != -1;
                },

                async loadAvailableFiles() {
                    try {
                        this.is_loading = true;
                        this.file_search_offset = 0;
                        
                        // Load files, datasets, and segments
                        //Add segmentsResponse to the const array to add segments back in
                        const [filesResponse, datasetsResponse] = await Promise.all([
                            window.axios.get(`/api/files/${this.client.url}/list/0`),
                            window.axios.get(`/api/data_set/${this.client.url}`),
                        ]);

                        // Process files
                        const files = filesResponse.data.files
                            .filter(file => file.status === 'ready' && file.columns !== null)
                            .map(file => ({
                                value: file.id,
                                columns: Object.entries(file.columns).map(([key, value]) => ({
                                    id: key,
                                    label: value
                                })),
                                text: file.name,
                                created_at: file.created_at,
                                type: 'file'
                            }));

                        // Process datasets
                        const datasets = (datasetsResponse.data.data || [])
                            .map(dataset => ({
                                value: dataset.id,
                                text: dataset.name,
                                columns: dataset.columns.map(column => ({
                                    id: column.id,
                                    label: column.display_name
                                })),
                                created_at: dataset.created_at,
                                type: 'dataset'
                            }));

                            /*
                        // Process segments
                        const segments = (segmentsResponse.data.segments || [])
                            .filter(segment => {
                                // Filter out segments that don't match the data source
                                if (this.data_source_id && segment.data_source_id !== this.data_source_id) {
                                    return false;
                                }
                                // Filter out the current segment if this is an update
                                if (this.value && this.value.id && segment.id === this.value.id) {
                                    return false;
                                }
                                return true;
                            })
                            .map(segment => ({
                                value: segment.id,
                                text: segment.name,
                                type: 'segment',
                                source: segment.source
                            }));
                            */

                        // Store all types separately
                        this.available_files = files;
                        this.available_datasets = datasets;
                        //this.available_segments = segments;
                        this.total_files = files.length;
                        this.total_datasets = datasets.length;
                        this.hasMoreFiles = filesResponse.data.files.length == 25;
                        this.is_loading = false;
                        this.files_loaded = true;
                    } catch (error) {
                        console.error('Error loading available files, datasets, and segments:', error);
                        this.available_files = [];
                        this.available_datasets = [];
                        this.available_segments = [];
                        this.is_loading = false;
                        this.hasMoreFiles = false;
                        this.files_loaded = false;
                    }
                },

                async searchFiles(search) {
                    if (!search) {
                        this.loadAvailableFiles();
                        return;
                    }

                    try {
                        this.is_loading = true;
                        this.file_search_offset = 0;
                        this.file_search_pattern = search;

                        // Search files, datasets, and segments
                        //Add segmentsResponse to the const array to add segments back in
                        const [filesResponse, datasetsResponse] = await Promise.all([
                            window.axios.post(`/api/files/${this.client.url}/list_by_pattern`, {
                                pattern: '%'+search+'%',
                                offset: 0,
                                page_size: 25
                            }),
                            window.axios.get(`/api/data_set/${this.client.url}`),
                        ]);
                        
                        // Process files
                        const files = filesResponse.data.files
                            .filter(file => file.status === 'ready' && file.columns !== null)
                            .map(file => ({
                                value: file.id,
                                text: file.name,
                                columns: Object.entries(file.columns).map(([key, value]) => ({
                                    id: key,
                                    label: value
                                })),
                                created_at: file.created_at,
                                type: 'file'
                            }));

                        // Process and filter datasets
                        const datasets = (datasetsResponse.data.data || [])
                            .filter(dataset => dataset.name.toLowerCase().includes(search.toLowerCase()) && dataset.columns !== null)
                            .map(dataset => ({
                                value: dataset.id,
                                text: dataset.name,
                                columns: dataset.columns.map(column => ({
                                    id: column.id,
                                    label: column.display_name
                                })),
                                created_at: dataset.created_at,
                                type: 'dataset'
                            }));
/*
                        // Process and filter segments
                        const segments = (segmentsResponse.data.segments || [])
                            .filter(segment => {
                                // Filter by search term
                                if (!segment.name.toLowerCase().includes(search.toLowerCase())) {
                                    return false;
                                }
                                // Filter out segments that don't match the data source
                                if (this.data_source_id && segment.data_source_id !== this.data_source_id) {
                                    return false;
                                }
                                // Filter out the current segment if this is an update
                                if (this.value && this.value.id && segment.id === this.value.id) {
                                    return false;
                                }
                                return true;
                            })
                            .map(segment => ({
                                value: segment.id,
                                text: segment.name,
                                type: 'segment',
                                source: segment.source
                            }));
*/
                        // Store all types separately
                        this.available_files = files;
                        this.available_datasets = datasets;
                        //this.available_segments = segments;
                        this.total_files = files.length;
                        this.total_datasets = datasets.length;
                        this.hasMoreFiles = filesResponse.data.files.length == 25;
                        this.is_loading = false;
                    } catch (error) {
                        console.error('Error searching files, datasets, and segments:', error);
                        this.available_files = [];
                        this.available_datasets = [];
                        this.available_segments = [];
                        this.is_loading = false;
                        this.hasMoreFiles = false;
                    }
                },

                async loadMoreFiles() {
                    if (this.is_loading) return;

                    try {
                        this.is_loading = true;
                        this.file_search_offset += 25;

                        // Store current scroll position
                        const dropdown = document.querySelector('.vs__dropdown-menu');
                        const scrollPosition = dropdown ? dropdown.scrollTop : 0;

                        let response;
                        if (this.file_search_pattern) {
                            response = await window.axios.post(`/api/files/${this.client.url}/list_by_pattern`, {
                                pattern: this.file_search_pattern,
                                offset: this.file_search_offset,
                                page_size: 25
                            });
                        } else {
                            response = await window.axios.get(`/api/files/${this.client.url}/list/${this.file_search_offset}`);
                        }

                        const newFiles = response.data.files
                            .filter(file => file.status === 'ready' && file.columns !== null)
                            .map(file => ({
                                value: file.id,
                                text: file.name,
                                columns: Object.entries(file.columns).map(([key, value]) => ({
                                    id: key,
                                    label: value
                                })),
                                created_at: file.created_at,
                                type: 'file'
                            }));

                        this.available_files = [...this.available_files, ...newFiles];
                        this.hasMoreFiles = response.data.files.length == 25;
                        this.is_loading = false;

                        // Restore scroll position after the DOM updates
                        this.$nextTick(() => {
                            if (dropdown) {
                                dropdown.scrollTop = scrollPosition;
                            }
                        });
                    } catch (error) {
                        console.error('Error loading more files:', error);
                        this.is_loading = false;
                    }
                },

                async handleFileSelection(el) {
                    const unit = this.data_filter.logic_units[el];
                    if (!unit.selected_file) {
                        unit.selected_column = null;
                        unit.value = null;
                        // Clear validation error when clearing file selection
                        unit.validation_error = null;
                        return;
                    }

                    // For segments, set the value directly
                    if (this.isSegmentOperator(unit.operator)) {
                        unit.value = unit.selected_file.value;
                        unit.selected_column = null;
                    }

                    // Initialize tooltips after file selection
                    this.$nextTick(() => {
                        this.initTooltips();
                    });

                    // Validate file ID column if this is a file operator and we have all required fields
                    if (this.isFileOperator(unit.operator) && 
                        unit.db_column && 
                        unit.selected_file && 
                        unit.selected_column) {
                        this.debouncedValidateFileIDColumn(el);
                    }

                    //Refresh the screen
                    this.$forceUpdate();
                },

                async handleColumnSelection(el) {
                    const unit = this.data_filter.logic_units[el];
                    if (unit.selected_column) {
                        unit.value = {
                            file_id: unit.selected_file.value,
                            column: unit.selected_column.value
                        };
                    }
                    
                    // Validate file ID column if this is an IN_FILE or NOT_IN_FILE operator
                    if (this.isFileOperator(unit.operator)) {
                        this.debouncedValidateFileIDColumn(el);
                    }
                },

                async handleDatabaseColumnChange(el) {
                    const unit = this.data_filter.logic_units[el];
                    
                    // Clear validation error when database column changes
                    unit.validation_error = null;
                    
                    // Clear column removed error when user selects a new column
                    if (unit.column_removed_error) {
                        unit.column_removed_error = null;
                    }
                    
                    // Validate file ID column if this is a file operator and we have all required fields
                    if (this.isFileOperator(unit.operator) && 
                        unit.db_column && 
                        unit.selected_file && 
                        unit.selected_column) {
                        this.debouncedValidateFileIDColumn(el);
                    }
                },

                async validateFileIDColumn(el) {
                    const unit = this.data_filter.logic_units[el];
                    
                    // Only validate if we have all required fields
                    if (!unit.db_column || !unit.selected_file || !unit.selected_column) {
                        return;
                    }
                    
                    try {
                        //Clear the old validation error
                        unit.validation_error = null;
                        
                        const response = await window.axios.post(`/api/segment/${this.client.url}/validate`, {
                            source_column: unit.db_column.value,
                            source_type: this.source,
                            source_id: this.data_source_id,
                            file_id: unit.selected_file.value,
                            destination_column: unit.selected_column.id
                        });
                        
                        // Clear any existing error
                        unit.validation_error = null;
                        
                        // If there's a warning message, show it
                        if (response.data.message) {
                            unit.validation_error = response.data.message;
                        }
                        
                        // Update the UI to show the validation result
                        this.$forceUpdate();
                        
                    } catch (error) {
                        console.error('Error validating file ID column:', error);
                        unit.validation_error = 'Error validating column match. Please try again.';
                        this.$forceUpdate();
                    }
                },

                isFileOperator(operator) {
                    if (!operator) return false;
                    
                    const operatorValue = typeof operator === 'object' ? operator.value : operator;
                    return operatorValue === 'IN_FILE' || operatorValue === 'NOT_IN_FILE';
                },

                formatDate(date) {
                    return moment(date).format('MM/DD/YYYY');
                },
                getAvailableOptions(unit) {
                    if (!unit || !unit.operator) return [];
                    
                    const operator = typeof unit.operator === 'object' ? unit.operator.value : unit.operator;
                    
                    if (operator === 'IN_FILE' || operator === 'NOT_IN_FILE') {
                        return this.available_files;
                    } else if (operator === 'IN_DATASET' || operator === 'NOT_IN_DATASET') {
                        return this.available_datasets;
                    } else if (operator === 'IN_AUDIENCE' || operator === 'NOT_IN_AUDIENCE') {
                        return this.available_segments;
                    }
                    
                    return [];
                },
                getPlaceholderText(unit) {
                    if (!unit || !unit.operator) return '';
                    
                    const operator = typeof unit.operator === 'object' ? unit.operator.value : unit.operator;
                    
                    if (operator === 'IN_FILE' || operator === 'NOT_IN_FILE') {
                        return 'Select a file...';
                    } else if (operator === 'IN_DATASET' || operator === 'NOT_IN_DATASET') {
                        return 'Select a dataset...';
                    } else if (operator === 'IN_AUDIENCE' || operator === 'NOT_IN_AUDIENCE') {
                        return 'Select an audience...';
                    }
                    
                    return '';
                },
                getLoadingText(unit) {
                    if (!unit || !unit.operator) return '';
                    
                    const operator = typeof unit.operator === 'object' ? unit.operator.value : unit.operator;
                    
                    if (operator === 'IN_FILE' || operator === 'NOT_IN_FILE') {
                        return 'Loading files...';
                    } else if (operator === 'IN_DATASET' || operator === 'NOT_IN_DATASET') {
                        return 'Loading datasets...';
                    } else if (operator === 'IN_AUDIENCE' || operator === 'NOT_IN_AUDIENCE') {
                        return 'Loading audiences...';
                    }
                    
                    return '';
                },
                isSegmentOperator(operator) {
                    if (!operator) return false;
                    
                    const segmentOperators = ['IN_AUDIENCE', 'NOT_IN_AUDIENCE'];
                    return segmentOperators.includes(operator.value);
                },
                getDisplayText(text) {
                    if (!text) return '';
                    
                    // Try different possible separators
                    const separators = [' › ', ' > ', ' - ', ': '];
                    for (const separator of separators) {
                        if (text.includes(separator)) {
                            const parts = text.split(separator);
                            return parts.pop();
                        }
                    }
                    
                    return text;
                },
            },
        }
    </script>
